//H5判断浏览器是微信还是支付宝
export function isAlipayOrWechat() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  console.log("微信还是支付宝")
  if (userAgent.match(/Alipay/i) == "alipay") {
    //alert("支付宝浏览器");   
    return "alipay";
  } else if (userAgent.match(/MicroMessenger/i) == "micromessenger") {
    // alert("微信浏览器");   
    return "wx";
  } else {
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js